import { render } from "./ModalEditarProduto.vue?vue&type=template&id=41f27e75&scoped=true"
import script from "./ModalEditarProduto.vue?vue&type=script&lang=js"
export * from "./ModalEditarProduto.vue?vue&type=script&lang=js"

import "./ModalEditarProduto.vue?vue&type=style&index=0&id=41f27e75&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f27e75"]])

export default __exports__